<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <defs>
            <pattern :id="patternId" patternUnits="userSpaceOnUse" width="2" height="2" patternTransform="rotate(45)">
                <rect width="1" height="2" fill="currentColor" x="0" y="0"></rect>
            </pattern>
        </defs>

        <path
            :fill="`url(#${patternId})`"
            d="M3.333 6.667a1.929 1.929 0 0 1-1.416-.583A1.929 1.929 0 0 1 1.333 4.667c0-.556.195-1.028.584-1.417A1.929 1.929 0 0 1 3.333 2.667h9.334c.555 0 1.027.194 1.416.583.39.39.584.861.584 1.417s-.195 1.028-.584 1.417a1.929 1.929 0 0 1-1.416.583H3.333Z"
        />

        <path
            fill="currentColor"
            d="M3.333 13.333a1.929 1.929 0 0 1-1.416-.583A1.929 1.929 0 0 1 1.333 11.333c0-.556.195-1.028.584-1.417A1.929 1.929 0 0 1 3.333 9.333h9.334c.555 0 1.027.194 1.416.583.39.39.584.861.584 1.417s-.195 1.028-.584 1.417a1.929 1.929 0 0 1-1.416.583H3.333Z"
        />
    </svg>
</template>

<script setup lang="ts">
import { useId } from 'vue';

type StripedSolidBarsIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<StripedSolidBarsIconProps>();
const patternId = useId();
</script>
